// -------- 用户相关 --------
import fetch from "./http";

// 用户基本信息
export function userInfo() {
  return fetch({
    url: "/user/info",
  });
}

// 收集水晶
export function collectCrystal() {
  return fetch({
    url: "/user/collect-crystal",
  });
}

// 选择初始怪兽
export function myFirstPet(params) {
  return fetch({
    url: "/user/choose-first-monster",
    params,
  });
}

// 新手引导相关
export function guideStatus() {
  return fetch({
    url: "/guide/guide-status",
  });
}

// 提交新手引导结束
export function sendGuideState(params) {
  return fetch({
    url: "/guide/sub",
    params,
  });
}
